import { render, staticRenderFns } from "./AnexosList.vue?vue&type=template&id=13126f10&scoped=true"
import script from "./AnexosList.vue?vue&type=script&lang=js"
export * from "./AnexosList.vue?vue&type=script&lang=js"
import style0 from "./AnexosList.vue?vue&type=style&index=0&id=13126f10&prod&lang=scss"
import style1 from "./AnexosList.vue?vue&type=style&index=1&id=13126f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13126f10",
  null
  
)

export default component.exports